import { render, staticRenderFns } from "./bargainJoinRecord.vue?vue&type=template&id=3e5128cd&scoped=true"
import script from "./bargainJoinRecord.vue?vue&type=script&lang=js"
export * from "./bargainJoinRecord.vue?vue&type=script&lang=js"
import style0 from "./bargainJoinRecord.vue?vue&type=style&index=0&id=3e5128cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5128cd",
  null
  
)

export default component.exports